<template>
  <div class="OrderManagement">
    <template v-if="nowPage == '修改完工回報'"><modOrderRecord /></template>
    <template v-else-if="nowPage == '新增完工回報'"
      ><addOrderRecord
    /></template>
    <template v-else-if="nowPage == '人工處理紀錄'"
      ><manualRecord
    /></template>
  </div>
</template>

<script>
import modOrderRecord from "@/components/modOrderRecord.vue";
import addOrderRecord from "@/components/addOrderRecord.vue";
import manualRecord from "@/components/manualRecord.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "OrderManagement",
  data() {
    return {
      nowPage: ""
    };
  },
  created: function() {
    window.addEventListener("beforeunload", this.setSessionItems);
    let page = sessionStorage.getItem("order_management_page");
    if (page == "修改完工回報") {
      this.set_sideBarSelect(["ordermanagement", "modorderrecord"]);
    } else if (page == "新增完工回報") {
      this.set_sideBarSelect(["ordermanagement", "addorderrecord"]);
    } else if (page == "人工處理紀錄") {
      this.set_sideBarSelect(["ordermanagement", "manualrecord"]);
    }

    sessionStorage.removeItem("order_management_page");
    this.change_selectPage("ordermanagement");
    this.change_selectPageName(this.pageName.ordermanagement);
  },
  mounted: function() {},
  components: {
    modOrderRecord,
    addOrderRecord,
    manualRecord
  },
  watch: {
    sideBarSelect: {
      handler() {
        let vm = this;
        vm.nowPage = vm.sideBarSelect.processName;
      }
    }
  },
  computed: {
    ...mapGetters({
      axiosResult: "commonaxios/get_axiosResult",
      pageName: "getlogin/get_pageName",
      sideBarSelect: "sideBarTree/get_sideBarSelect"
    })
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      change_selectPage: "getlogin/change_selectPage",
      change_selectPageName: "getlogin/change_selectPageName",
      set_sideBarSelect: "sideBarTree/set_sideBarSelect"
    }),
    setSessionItems() {
      sessionStorage.setItem(
        "order_management_page",
        this.sideBarSelect.processName
      );
    },
    onClick() {},
    //資料reset
    reset(keep) {
      var def = this.$options.data();
      for (var i = 0; i < keep.length; i++) {
        def[keep[i]] = this[keep[i]];
      }
      Object.assign(this.$data, def);
      //https://codepen.io/karimcossutti/pen/ObXyKq
    }
  },
  destroyed() {
    window.removeEventListener("beforeunload", this.setSessionItems);
  }
};
</script>

<style scoped></style>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/views/OrderManagement.vue